/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ShootInputs */

const en_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot.`)
};

const es_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispara.`)
};

const fr_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photographiez.`)
};

const de_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnehmen.`)
};

const ja_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`撮影。`)
};

const zh_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拍摄。`)
};

const ar_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صوّر.`)
};

const id_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potret.`)
};

const it_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scatta.`)
};

const ru_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Снимай.`)
};

const pt_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografe.`)
};

const ko_shoot = /** @type {(inputs: ShootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`촬영.`)
};

/**
* | output |
* | --- |
* | "Shoot." |
*
* @param {ShootInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shoot = /** @type {((inputs?: ShootInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ShootInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shoot(inputs)
	if (locale === "es") return es_shoot(inputs)
	if (locale === "fr") return fr_shoot(inputs)
	if (locale === "de") return de_shoot(inputs)
	if (locale === "ja") return ja_shoot(inputs)
	if (locale === "zh") return zh_shoot(inputs)
	if (locale === "ar") return ar_shoot(inputs)
	if (locale === "id") return id_shoot(inputs)
	if (locale === "it") return it_shoot(inputs)
	if (locale === "ru") return ru_shoot(inputs)
	if (locale === "pt") return pt_shoot(inputs)
	return ko_shoot(inputs)
});